import { CompanySearchResultInterface } from '../../Interfaces/CompanySearchResultInterface'

export const formatCompanySearchResult = (rows: CompanySearchResultInterface[]) => {
  const capitalize = (str: string) => {
    return str.substr(0, 1).toUpperCase().concat(str.substr(1).toLowerCase())
  }

  return rows.map((row) => {
    const newRow: CompanySearchResultInterface = {
      ...row,
      name: (row.name || '').toLowerCase(),
      address1: (row.address1 || '').toLowerCase(),
      address2: (row.address2 || '').toLowerCase(),
      city: (row.city || '').toLowerCase(),
    }
    Object.keys(newRow).forEach((str) => {
      if (newRow[str] !== '') {
        newRow[str] = capitalize(newRow[str])
      }
    })
    return newRow
  })
}
